export enum ControlMode {
  OversightControl = 'oversight_control',
  LegacyControl = 'legacy_control',
}
